import apiClient from "../client";
import { cachedGet } from "../cache";
import { API_ENDPOINTS } from "../endpoints";
import type {
  ApiResponse,
  PaginatedApiResponse,
  Product,
  ProductFilters,
  ProductPhoto,
  TrackingResponse,
} from "../interface";

export const productService = {
  async getAll(params: ProductFilters = {}) {
    return cachedGet<PaginatedApiResponse<Product>>(
      API_ENDPOINTS.products.all,
      { params }
    );
  },

  async getBySlug(slug: string) {
    return cachedGet<ApiResponse<Product>>(
      API_ENDPOINTS.products.detail(slug)
    );
  },

  async getPhotos(slug: string) {
    return cachedGet<ApiResponse<ProductPhoto[]>>(
      API_ENDPOINTS.products.photos(slug)
    );
  },

  async registerView(slug: string) {
    const response = await apiClient.post<TrackingResponse>(
      API_ENDPOINTS.products.view(slug)
    );

    return response.data;
  },

  async registerWhatsAppClick(slug: string) {
    const response = await apiClient.post<TrackingResponse>(
      API_ENDPOINTS.products.whatsappClick(slug)
    );

    return response.data;
  },

  async registerTelegramClick(slug: string) {
    const response = await apiClient.post<TrackingResponse>(
      API_ENDPOINTS.products.telegramClick(slug)
    );

    return response.data;
  },
};
